export default {
    createFromArray(array, columns){
        return array.reduce((reduced, element, index)=>{
            return (index % columns === 0 ? reduced.push([element]) : reduced[reduced.length - 1].push(element)) && reduced
        }, []);
    },
}



//////////////////
// WEBPACK FOOTER
// ./public/js/services/arrayTable.js
// module id = 536
// module chunks = 0